<div class="row container-form">
  <div class="row">
    <span class="d-flex justify-content-start gap-4">
      <p><b>Sucursal: </b>{{branchName}}</p>
      <p><b>Nro. Corte: </b>{{invoicingCutoffCode}}</p>
    </span>
  </div>
  <div>
    <form [formGroup]="formInvoiceInvoicingCutoff">
      <div class="row">
        <div class="col-6 col-lg-4">
          <app-custom-datepicker formControlName="dateInvoicing" [labelText]="'Fecha Factura'" [required]="true"
            (onChangeDate)="changeDayExpiration()"></app-custom-datepicker>
        </div>
        <div class="col-12 col-lg-3">
          <app-custom-input-number formControlName="invoiceExpirationDays" [labelText]="'Días Vecim.'"
            (onChangeNumber)="changeDayExpiration()"></app-custom-input-number>
        </div>
        <div class="col-6 col-lg-4">
          <app-custom-input-text [disabled]="true" [labelText]="'Fecha Vencimiento'"
            [value]="dateExpiration"></app-custom-input-text>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="row">
  <div class="d-flex justify-content-end gap-2 mt-3">
    <app-custom-button [disabled]="disabledToInvoice" [label]="'Procesar'" [title]="'Procesar'"
      (onClick)="invoiceInvoicingCutoff()"></app-custom-button>
    <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'"
      (onClick)="close()"></app-custom-button>
  </div>
</div>